
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"15","height":"10","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#fff","fill-rule":"evenodd","d":"M10.182 9.79a.789.789 0 01-.136-.779.717.717 0 01.136-.232l3.308-3.78-3.308-3.778A.758.758 0 0110 .715a.758.758 0 01.183-.506.632.632 0 01.203-.155.557.557 0 01.479 0 .632.632 0 01.203.155l3.75 4.285a.794.794 0 01-.001 1.011l-3.75 4.285a.592.592 0 01-.442.21.565.565 0 01-.24-.055.625.625 0 01-.202-.155z","clip-rule":"evenodd"}}),_c('path',{attrs:{"fill":"#fff","fill-rule":"evenodd","d":"M14.374 5c0 .19-.066.37-.183.505a.587.587 0 01-.442.209H.625a.585.585 0 01-.442-.21A.763.763 0 010 5c0-.19.066-.371.183-.505a.588.588 0 01.442-.21h13.124c.166 0 .325.076.442.21a.769.769 0 01.183.505z","clip-rule":"evenodd"}})])
          )
        }
      }
    